import script from "./HrEmployeeStatusBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./HrEmployeeStatusBadge.vue?vue&type=script&lang=ts&setup=true"

import "./HrEmployeeStatusBadge.vue?vue&type=style&index=0&id=34bf6681&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34bf6681"]])

export default __exports__